var slideshowClick = require('./slideshow-click'),
	slideshowAnimations = require('./slideshow-animations');
	slideshowEvents = function(slide) {
		var $slideItems = slide.querySelector('.coto_slide-items'),
			$slideshowNav = slide.querySelector('.coto_slideshow-nav'),
			$slideshowNavButton = $slideshowNav.getElementsByTagName('button'),
			$slideshowButton = slide.querySelectorAll('.coto_slide-button');

		// Slideshow Button
		for (let $button of $slideshowButton) {
			$button.addEventListener('click', function() {
				var direction = 'right';

				if (this.classList.contains('prev')) {
					direction = 'left';
				}

				slideshowAnimations(slide, null, direction);
			});
		}

		// Slideshow Nav Button
		for (let $navButton of $slideshowNavButton) {
			$navButton.addEventListener('click', function() {
				var isActive = this.classList.contains('active'),
					index = [...this.parentElement.children].indexOf(this);

				if (!isActive) {
					slideshowClick(slide, this);
					slideshowAnimations(slide, index);
				}
			});
		}

		// Slide show Swipe
		let touchStartX = 0,
			touchEndX = 0;

		$slideItems.addEventListener('touchstart', function(event) {
			touchStartX = event.changedTouches[0].screenX;
		});

		$slideItems.addEventListener('touchend', function(event) {
			var direction = 'right';
			
			touchEndX = event.changedTouches[0].screenX;

			if (touchEndX > touchStartX) {
				direction = 'left';
			}

			slideshowAnimations(slide, null, direction);
		});
	};

module.exports = slideshowEvents;